import { createSlice } from '@reduxjs/toolkit';

export interface FaceCaptureState {
  /* TODO: model face-capture's client-only state. */
}

const initialState: FaceCaptureState = {};

export const faceCaptureSlice = createSlice({
  name: 'faceCapture',
  initialState,
  reducers: {},
});

export default faceCaptureSlice.reducer;
